<template>
    <div>
        <input type="text" placeholder="search for..." />
        <button>Cancel</button>
    </div>
</template>
<script>
export default {
    props: {
    }
}
</script>
<style lang="scss" scoped>
    div {
        position: absolute;
        border:1px solid lightgray;
        background-color:white;
        padding:20px;
    }
</style>